module.exports = __webpack_public_path__ + "static/media/MyDashboardIcon.f2e0c3c4.svg";